import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import EditIcon from '@mui/icons-material/Edit'; 

export default function PickupRequestsAdminList(props){
    //console.debug("RTS Break PickupRequestsAdminList");

    const history = useNavigate();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    function handleClick(e, cellValues){
        history("/PickupRequestsAdminEdit", {state: {idGuid:cellValues.row.idGuid, display:cellValues.row.customerName + " (" + cellValues.row.customerIdSap + ")", mode:1}});
    }


    const columns = [
        {
            field: "Edit",
            headerName: "",
            description:"Edit Project", 
            flex:1,
            maxWidth:60,
            renderCell: (cellValues) => {
                return (
                    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', alignContent:'center', pt:.5}}>
                        <Link onClick={(event) => {handleClick(event, cellValues);}} sx={{textDecoration:'none', cursor:'pointer'}}>
                            <EditIcon />
                        </Link>
                    </Box>
                );
            },
            align:"center",
            sortable:false,
            filterable:false,
            hideable:false,
            disableColumnMenu:true
        },
        {
            field: 'name', 
            headerName: "Name", 
            description:"Pickup Request Name", 
            flex:4,    
            hideable:false,
        },
        {
            field: 'loadCount', 
            headerName: "# Reels", 
            description:"Number of Reels",
            type: 'number', 
            flex:1    
        },
        {
            field: 'createDate', 
            headerName: "Create Date", 
            description:"Create Date", 
            flex:2,           
            valueGetter: (value, row) => {
                if(value == null){
                    return null;
                }

                return (
                    new Date(value)
                );
            },
            type:"date",
            valueFormatter: (value) => {
                if(value == null){
                    return null;
                }
                
                const formatObj = new Intl.DateTimeFormat("en-US");
                return (
                    formatObj.format(new Date(value))
                );
            }, 
        },
        {
            field: 'submitDate', 
            headerName: "Submit Date", 
            description:"submit Date", 
            flex:2,           
            valueGetter: (value, row) => {
                if(value == null){
                    return null;
                }

                return (
                    new Date(value)
                );
            },
            type:"date",
            valueFormatter: (value) => {
                if(value == null){
                    return null;
                }
                
                const formatObj = new Intl.DateTimeFormat("en-US");
                return (
                    formatObj.format(new Date(value))
                );
            }, 
        },
        {
            field: 'onSiteContactName', 
            headerName: "Contact", 
            description:"On Site Contact Name",
            flex:2    
        },
        {
            field: 'siteCloseDate', 
            headerName: "Site Close", 
            description:"Site Close Date", 
            flex:2,           
            valueGetter: (value, row) => {
                if(value == null){
                    return null;
                }

                return (
                    new Date(value)
                );
            },
            type:"date",
            valueFormatter: (value) => {
                if(value == null){
                    return null;
                }
                
                const formatObj = new Intl.DateTimeFormat("en-US");
                return (
                    formatObj.format(new Date(value))
                );
            }, 
        },
        {
            field: 'city', 
            headerName: "City", 
            description:"City",
            flex:2    
        }, 
        {
            field: 'zip', 
            headerName: "Zip", 
            description:"Zip Code",
            flex:2    
        },
        {
            field: 'status', 
            headerName: "Status", 
            description:"Pickup Request Status",
            flex:2,    
            renderCell: (cellValues) => {
                if(cellValues.value === 75){
                    return ('Submitted');
                }
                else if(cellValues.value === 75){
                    return('Completed');
                }
                else{
                    return('Work In Progress');
                }
            },     
        },                                                
    ];


    function getVisibilityModel(){
        if(smallForm){
            return {createDate:false, submitDate:false, onSiteContactName:false, siteCloseDate:false, city:false, zip:false, status:false,}
        }
        else{
            return {onSiteContactName:false, siteCloseDate:false, city:false, zip:false, status:false,}
        }
    }


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    }


    return (
        <Box sx={{width:'100%', height:'100%', minHeight:'400px'}}>
            <DataGridPro
                pagination={true}
                slots={{toolbar: GridToolbar}}
                slotProps={{
                    toolbar:{
                        showQuickFilter:true,
                    }
                }}
                rows={props.data} 
                columns={columns} 
                getRowId={row => row.idGuid}
                initialState={{
                    columns:{
                        columnVisibilityModel: getVisibilityModel()
                    },
                    pagination: { paginationModel: { pageSize: 50 } },
                    density: getDensity() 

                }}                
            />
        </Box>
    );
}
